"use client";

import React, { useState, useRef, useEffect } from "react";
import Image from "next/image";
import Maps from "@/components/partials/Maps";

export default function Contato({ data}) {
  const banner = data?.contentAttachments1?.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage
      }
    }

    return false;
  }).filter(f => f !== false)[0] || [];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    "Escolha o setor que deseja conversar"
  );
  const dropdownRef = useRef(null);
  const options = ["Contabilidade", "Consultoria", "Outro"];

  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="w-full flex flex-col items-center bg-gray-50">

      {/* Banner fullwidth */}
      <section className="relative w-full h-[400px] md:h-[600px] overflow-hidden">
        <Image
          src={ banner.src }
          alt="Contato LG Centro Contábil"
          fill
          priority
          className="object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center px-4">
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-bold text-center">
            Fale Conosco
          </h1>
        </div>
      </section>

      {/* Logo centralizado */}
      <section className="w-full py-12 bg-white">
        <div className="max-w-[1440px] mx-auto flex justify-center">
          <Image
            src="/assets/logos1.png"
            alt="Logo LG Centro Contábil"
            width={500}
            height={200}
            className="object-contain"
          />
        </div>
      </section>
    </div>
  );
}
